<template>
  <materials-scanner
    @screen-closed="() => $emit('closed')"
    ref="materialsScanner"
  />
</template>

<script>
  import MaterialsScanner from "../../../materials-scanner/materials-scanner.vue";

  export default {
    name: "easyscreen-menu-return-screen",
    methods: {
      /**
       * Open the self check return screen.
       *
       * @param {Function} callback - Callback, will be called when screen is opend.
       */
      show(callback) {
        this.$refs.materialsScanner.show("return", callback);
      },
      /**
       * Close the self check return screen.
       *
       * @param {Function} callback - Callback, will be called when screen is closed.
       */
      hide(callback) {
        this.$refs.materialsScanner.hide("return", callback);
      }
    },
    components: {
      "materials-scanner": MaterialsScanner
    }
  };
</script>
